export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const SET_ENTRANCES_IN_VIEW = 'SET_ENTRANCES_IN_VIEW';
export const SET_SEARCH_FIELD_VALUE = 'SET_SEARCH_FIELD_VALUE';
export const RESET_SEARCH_FIELD_VALUE = 'RESET_SEARCH_FIELD_VALUE';
export const SET_CURRENT_HOUSE = 'SET_CURRENT_HOUSE';
export const SET_CURRENT_FLAT = 'SET_CURRENT_FLAT';
export const SET_FLATS_GRID_DATA = 'SET_FLATS_GRID_DATA';
export const SET_FLATS_TABLE_DATA = 'SET_FLATS_TABLE_DATA';
export const SET_FLATS_VIEW = 'SET_FLATS_VIEW';
export const SET_HOUSES_VIEW = 'SET_HOUSES_VIEW';
export const SET_ACTIVE_ENTRANCE_NAME = 'SET_ACTIVE_ENTRANCE_NAME';
export const SET_FLATS_TABLE_PAGE = 'SET_FLATS_TABLE_PAGE';
export const SET_HOUSES_TABLE_PAGE = 'SET_HOUSES_TABLE_PAGE';
export const SET_DOC_FORM_DATA = 'SET_DOC_FORM_DATA';
export const SET_METER_MODAL_DATA = 'SET_METER_MODAL_DATA';
export const SET_FLATS_GRID_PREVIEW_DATA = 'SET_FLATS_GRID_PREVIEW_DATA';
export const SET_TEMPLATE_MODAL_DATA = 'SET_TEMPLATE_MODAL_DATA';
export const SET_CURRENT_HOUSES_REGISTER = 'SET_CURRENT_HOUSES_REGISTER ';
export const SET_SELECTED_FLATS = 'SET_SELECTED_FLATS';
export const SET_AVAILABLE_HOUSE = 'SET_AVAILABLE_HOUSE';
export const SET_AVAILABLE_FLAT = 'SET_AVAILABLE_FLAT';
export const SET_CHESS_VIEW_COLOR_MODE = 'SET_CHESS_VIEW_COLOR_MODE';
export const SET_MONITORING_STAGE = 'SET_MONITORING_STAGE';
export const SET_DATE_EXCESS = 'SET_DATE_EXCESS';
export const SET_REQUEST_VALUES_ATTRIBUTES = 'SET_REQUEST_VALUES_ATTRIBUTES';
export const OPEN_MODAL_TRANSPORTS_TENANT = 'OPEN_MODAL_TRANSPORTS_TENANT';
export const CLOSE_MODAL_TRANSPORTS_TENANT = 'CLOSE_MODAL_TRANSPORTS_TENANT';
export const SET_VISIBLE_TRANSPORT_FORM = 'SET_VISIBLE_TRANSPORT_FORM';